// Modules
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
// Styles
import Styles from "./Styles/LandingSliderCard.module.css";
// Images
import bookmarkImage from "../../../../Assets/Icons/bookmark.png";
import sendMessageImage from "../../../../Assets/Icons/send-message.png";
import viewCountIcon from "../../../../Assets/Icons/view_count.png";
import viewImage from "../../../../Assets/Icons/view.png";
import messageIcon from "../../../../Assets/Icons/message-white.png";
import toast from "react-hot-toast";
import convertNumbersToPersian from "../../../../Utils/convertNumbersToPersian";

const LandingSliderCard = ({
  item,
  kind,
  handleChangePosts,
  reservedIcons,
}) => {
  const {
    image,
    title,
    writer,
    translator,
    category,
    content,
    _id,
    comments,
    views,
    frontCover,
    shortDesc,
    icon,
  } = item;
  const contentRef = useRef(null);
  const [newText, setNewText] = useState("");
  useEffect(() => {
    if (contentRef) {
      setNewText(contentRef.current.innerText.slice(0, 100) + ". . .");
    }
  }, [contentRef]);

  return (
    <div className={Styles.container}>
      <div className={Styles.specificIcon}>
        <img src={reservedIcons.find((i) => i.name === icon).icon} alt="" />
      </div>
      <p
        style={{ display: "none" }}
        ref={contentRef}
        dangerouslySetInnerHTML={{
          __html: kind === "article" ? content : shortDesc,
        }}
      ></p>
      <div
        className={Styles.imageTitle}
        onClick={() => handleChangePosts(item)}
      >
        {category}
      </div>
      <img
        src={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${
          kind === "article" || kind === "visual" ? image : frontCover
        }`}
        alt=""
      />
      <div className={Styles.descContainer}>
        <div className={Styles.detailsContainer}>
          <h2 style={{ fontSize: "13px", whiteSpace: "pre-line" }}>{title}</h2>
          <p>{writer}</p>
          <p>{translator}</p>
        </div>
        <div className={Styles.desc}>
          <p>{newText}</p>
          <div className={Styles.buttons}>
            <Link
              to={
                kind === "book"
                  ? `/library/single-book/${_id}`
                  : `/article/${
                      item.kind === "textual"
                        ? "journal"
                        : item.kind === "visual"
                        ? "image-articles"
                        : "quarterly"
                    }/${_id}`
              }
              className={Styles.left}
            >
              مشاهده
              <img src={viewImage} alt="" />
            </Link>
            <div className={Styles.right}>
              <div className={Styles.iconContainer}>
                <img className={Styles.messageIcon} src={messageIcon} alt="" />
                <h5>{convertNumbersToPersian(comments?.length.toString())}</h5>
              </div>
              <div className={Styles.iconContainer}>
                <img src={viewCountIcon} alt="" />
                <h5>
                  {views.count
                    ? convertNumbersToPersian(views.count.toString())
                    : "۰"}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingSliderCard;
